import { Card, CardActions, CardContent, CardHeader, CardProps, Typography } from '@mui/material';
import { ReactNode } from 'react';

export interface StyledCardProps extends Omit<CardProps, 'children' | 'title'> {
  children: ReactNode;
  avatar?: ReactNode;
  title?: ReactNode;
  actions?: ReactNode | ReactNode[];
}

export function StyledCard({
  children,
  avatar,
  title,
  actions,
  elevation = 1,
  sx,
  ...cardProps
}: StyledCardProps) {
  return (
    <Card elevation={elevation} sx={{ width: '100%', ...sx }} {...cardProps}>
      {(avatar || title) && (
        <CardHeader
          avatar={avatar}
          title={
            title ? (
              <Typography variant="h6" component="h2">
                {title}
              </Typography>
            ) : undefined
          }
          sx={{
            '& .MuiCardHeader-avatar': {
              marginRight: 1,
            },
            backgroundColor: '#f9f9f9',
            borderBottom: '1px solid #f0f0f0',
          }}
        />
      )}
      <CardContent>{children}</CardContent>
      {actions && <CardActions>{actions}</CardActions>}
    </Card>
  );
}
